<!-- Option D app shell (docs/redesign): sidebar, top bar and the routed page, on every screen size.
     Phones and tablets get its own layouts (docs/redesign/mobile). -->
<bc-app-shell
  [loginDisplay]="loginDisplay"
  [menu]="menu"
  (changeModule)="changeModule($event)"
  (changeMenu)="changeMenu($event)"
  (logout)="logout()">
  <app-read-only-banner *ngIf="loginDisplay"></app-read-only-banner>
  <div class="outlet">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    <router-outlet *ngIf="!isIframe"></router-outlet>
  </div>
  <app-footer *ngIf="loginDisplay"></app-footer>
</bc-app-shell>
<app-phonebook-sidebar></app-phonebook-sidebar>
<app-meeting-notes-panel></app-meeting-notes-panel>
<!-- Only once a BizCombo user is signed in: there is no header to open it from otherwise. -->
<app-outlook-panel *ngIf="loginDisplay"></app-outlook-panel>
<app-active-timers *ngIf="loginDisplay"></app-active-timers>
<!-- "What are you looking for?": the open page's actions, from the top bar's finder button or Ctrl+/. -->
<bc-page-finder *ngIf="loginDisplay"></bc-page-finder>
<app-toast></app-toast>
